module.exports = "<!-- View/routes wrapper-->\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/layouts/blank.template.html
// module id = ../../../../../src/app/components/common/layouts/blank.template.html
// module chunks = 0